import http from '@/utils/http' //引入axios
// 语言数据
export const getLanguag = data => http.get('/kg-i18n/api/i18n', {
    params: data
})
export const addLanguage = data => http.post('/kg-i18n/api/i18n', data)
export const deleteLanguag = data => http.delete('/kg-i18n/api/i18n', {
    data
})
// 语言设置
export const getLanguageSet = data => http.get('/kg-i18n/api/lan', {
    params: data
})
export const addLanguageSet = data => http.post('/kg-i18n/api/lan', data)
export const updateLanguageSet = data => http.put('/kg-i18n/api/lan', data)
export const deleteLanguagSet = data => http.delete('/kg-i18n/api/lan', {
    params: data
})
export const getAllEnable = data => http.get('/kg-i18n/api/lan/getAllEnable', {
    params: data
})
export const getAllLanguag = data => http.get('/kg-i18n/api/lan/getEnable', {
    params: data
})
export const updateLnaguegeUser = data => http.get('/user-center/api/language', {
    params: data
})
export const updateLnaguegeRvm = data => http.get('/rvm-center/api/language', {
    params: data
})
export const updateLnaguegeMaintenance = data => http.get('/maintenance-center/api/language', {
    params: data
})
export default {
    getAllLanguag,
    getLanguageSet,
    addLanguageSet,
    updateLanguageSet,
    deleteLanguagSet,
    getLanguag,
    addLanguage,
    deleteLanguag,
    getAllEnable,
    updateLnaguegeUser,
    updateLnaguegeRvm,
    updateLnaguegeMaintenance
}